<template>
  <div class="about content-part">
    <div class="banner">
      <img :src="currentLg.banner" alt="" />
    </div>
    <div class="aboutUs">
      <div class="btn-list">
        <div
          class="btn"
          :class="{ 'btn-checked': type == index + 1 }"
          v-for="(i, index) in btnList"
          :key="index"
          @click="changeType(index)"
        >
          <span>{{ i[`name_${locale}`] }}</span>
          <img
            v-show="type == index + 1"
            src="./../assets/img/line.png"
            alt=""
          />
        </div>
      </div>

      <template v-if="type == 1">
        <div class="box">
          <div class="intro">
            <div class="left-img">
              <img src="./../assets/images/about/intro.png" alt="" />
            </div>
            <div class="right-info">
              <h4>{{ currentLg.intro }}</h4>
              <img src="./../assets/img/line.png" alt="" />
              <div class="lists">
                <p v-for="(i, index) in intro" :key="index">
                  {{ i[`name_${locale}`] }}
                </p>
              </div>
            </div>
          </div>
          <div class="honor">
            <h4>{{ currentLg.honor }}</h4>
            <img src="./../assets/img/line.png" alt="" />
            <div class="lists">
              <div class="honor-list">
                <img
                  :class="i <= 9 ? 'w250' : 'w200'"
                  v-for="i in imgList"
                  :key="i"
                  :src="require(`./../assets/images/about/${i + 1}.jpg`)"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="prod">
            <h4>{{ currentLg.knowledge }}</h4>
            <img src="./../assets/img/line.png" alt="" />
            <div class="knowledge">
              <div class="flex">
                <img src="./../assets/images/about/17.jpg" alt="" />
                <img src="./../assets/images/about/18.jpg" alt="" />
                <img
                  class="dizuo"
                  src="./../assets/images/about/19.png"
                  alt=""
                />
              </div>
              <img
                class="zhishi"
                src="./../assets/images/about/knowledge.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="cotent-airtical">
          <div class="linkUs">
            <div class="linkWay">
              <div class="item" v-for="(i, index) in companyInfo" :key="index">
                <img
                  :src="require(`./../assets/images/about/${index + 1}.png`)"
                  alt=""
                />
                <p class="p-title">{{ i[`title_${locale}`] }}</p>
                <p class="p-name">{{ i[`name_${locale}`] }}</p>
              </div>
            </div>
            <p class="ewm">
              <img src="../assets/img/ewm3.jpg" />
            </p>
          </div>
        </div>
        <baidu-map
          class="map"
          :center="{ lng: 113.948357, lat: 22.533454 }"
          :zoom="15"
          :scroll-wheel-zoom="true"
        >
          <bm-marker
            :position="{ lng: 113.948357, lat: 22.533454 }"
            :dragging="true"
          >
            <bm-info-window
              :position="{ lng: 113.948357, lat: 22.533454 }"
              :show="infoWindow.show"
            >
              <p>{{ currentLg[`address_${locale}`] }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map>
      </template>
    </div>
  </div>
</template>
<script>
import language from "./../language/about/index";
export default {
  data() {
    return {
      type: 1,
      intro: [
        {
          name_CN:
            "金马节能科技（深圳）有限公司（以下简称“金马节能”），致力于成为国内领先的专业综合二次能源供应商。公司聚焦工业领域及大型公共建筑，为客户提供蒸汽、压缩空气、冷冻水、冷却水等二次能源的生产、输配与智慧运维服务。立足深圳，设上海、北京分部，济南子公司，业务辐射全国。",
          name_EN:
            "BLEMS is committed to becoming a leading professional comprehensive secondary energy supplier in China. The company focuses on the industrial sector and large-scale public buildings, providing customers with services encompassing the production, transmission, distribution, and smart operation & maintenance of secondary energy sources such as steam, compressed air, chilled water, and cooling water. Headquartered in Shenzhen, the company has established branches in Shanghai and Beijing, and a subsidiary in Jinan, with its business radiating across the country.",
        },
        {
          name_CN:
            "金马节能是典型的产、学、研一体化发展平台，核心技术团队曾就职于清华大学建筑节能研究中心、上海市建筑科学研究院等国内知名科研机构。公司与国家节能中心、建设部科技发展促进中心、同济大学设施管理研究院（FM）、国际建筑业主与管理者协会（BOMA）保持深度合作，持续推动二次能源系统的能效技术研发与软件平台迭代。",
          name_EN:
            "BLEMS operates as a typical platform integrating production, education, and research. Its core technical team members have previously worked at renowned domestic research institutions like the Building Energy Research Center of Tsinghua University and the Shanghai Research Institute of Building Sciences. The company maintains deep collaborations with the National Energy Conservation Center, the Science and Technology Development Promotion Center of the Ministry of Housing and Urban-Rural Development, the Facilities Management Institute (FM) of Tongji University, and the Building Owners and Managers Association (BOMA) International, continuously advancing energy efficiency technology research and software platform iteration for secondary energy systems.",
        },
        {
          name_CN:
            "公司提供从能源站规划、建设到智慧运维的全生命周期解决方案。以“持续为业主创造新的利润中心”为宗旨，坚持实测数据说话，以“效果保障型”服务实现立竿见影的节能收益。通过优化二次能源系统效率，金马节能已为业主带来数亿计的能源成本节约、用能体验升级与资产增值。",
          name_EN:
            'The company provides full lifecycle solutions, ranging from energy station planning and construction to smart operation and maintenance. Guided by the principle of "continuously creating new profit centers for property owners," BLEMS insists on using measured data and delivers immediate energy-saving benefits through "performance-guaranteed" services. By optimizing the efficiency of secondary energy systems, BLEMS has generated hundreds of millions in energy cost savings for its clients, along with enhanced energy consumption experiences and asset appreciation.',
        },
        {
          name_CN:
            "金马节能，以科技赋能二次能源，致力成为智慧能源系统领跑者，以ESG理念支撑全面高质量发展。",
          name_EN:
            "BLEMS empowers secondary energy with technology, striving to become a leader in smart energy systems and supporting comprehensive, high-quality development with ESG principles.",
        },
      ],
      companyInfo: [
        {
          title_CN: "联系方式",
          name_CN: "0755-83239076",
          title_EN: "Contact",
          name_EN: "(+86) 0755-83239076",
        },
        {
          title_CN: "邮箱",
          title_EN: "E-mail",
          name_CN: "BLEMS@goldhorse-energy.com",
          name_EN: "BLEMS@goldhorse-energy.com",
        },
        {
          title_CN: "深圳总部",
          title_EN: "Shenzhen Headquarter",
          name_CN: "深圳市南山区高新南九道西北工业大学三航科技大厦2105",
          name_EN:
            "Room 2105, Sanhang Science & Technology Building, Northwestern Polytechnical University, Gaoxin South 9th Road, Nanshan District, Shenzhen, China",
        },
      ],
      btnList: [
        { name_CN: "公司简介", name_EN: "Company Profile" },
        { name_CN: "联系我们", name_EN: "Contact Us" },
      ],
      imgList: [...new Array(16).keys()],
      infoWindow: {
        show: true,
      },
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  methods: {
    changeType(index) {
      this.type = index + 1;
    },
  },
};
</script>

<style lang="less" scoped>
.map {
  width: 100%;
  height: 500px;
}
.about {
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.box {
  line-height: 30px;
  color: #666;

  .intro {
    display: flex;
    margin: 50px 5vw;
    .left-img {
      // width: 34vw;
      height: 40vh;
      margin-right: 4vw;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .right-info {
      flex: 1;
      .lists {
        margin-top: 2vh;
      }
    }
  }
}
.lists {
  margin-bottom: 20px;
}
h4 {
  font-size: 36px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #2a2a2a;
  margin-bottom: 14px;
}
.lists p {
  padding-bottom: 10px;
  line-height: 32px;
  text-indent: 30px;
  color: #666;
}
.btn-list {
  display: flex;
  border-bottom: 1px solid #d9d9d9;
  padding-left: 15vw;
}

.btn {
  cursor: pointer;
  position: relative;
  padding: 21px 0;
  margin-right: 120px;
  font-size: 16px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
  img {
    width: 39px;
    height: 4px;
    position: absolute;
    bottom: 0;
  }
}
.btn-checked {
  color: #1289d9;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cotent-airtical {
  box-sizing: border-box;
  margin: 50px 10vw;
  .compalian {
    text-indent: 28px;
    margin-bottom: 3px;
    line-height: 3em;
    span:first-child {
      font-size: 16px;
      text-indent: 38px;
      color: #666666;
    }
    span:last-child {
      font-size: 16px;
      text-indent: 38px;
      color: #666666;
    }
  }
}

.linkUs {
  display: flex;
  justify-content: space-between;
  .linkWay {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #666666;
    flex: 1;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 70px;

      img {
        width: 60px;
        height: 57px;
      }
    }
    .p-title {
      // padding: 36px 0 46px 0;
      font-size: 18px;
      font-family: SourceHanSansCN;
      font-weight: bold;
      color: #2a2a2a;
      line-height: 35px;
    }
    .p-name {
      font-size: 16px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #2a2a2a;
      line-height: 30px;
      text-align: center;
    }
  }
  .ewm {
    img {
      height: 140px;
      width: 140px;
    }
  }
}

.honor {
  background: #f0f0f0;
  text-align: center;
  padding: 0 6vw;
  h4 {
    text-align: center;
    padding-top: 65px;
  }
}
.honor-list {
  margin-top: 44px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 12px;
  .w250 {
    width: 14vw;
    margin-right: 14px;
    margin-bottom: 24px;
  }
  .w200 {
    width: 12vw;
    margin-right: 24px;
    margin-bottom: 24px;
  }
}

.prod {
  text-align: center;
  padding: 0 160px 65px 160px;
  h4 {
    text-align: center;
    padding-top: 71px;
  }
}

.knowledge {
  img {
    width: 100%;
  }
  .flex {
    display: flex;
    width: 800px;
    margin: 0 auto;
    justify-content: space-around;
    margin-bottom: 20px;
    position: relative;
    img {
      width: 230px;
      height: 325px;
      opacity: 1;
      margin-right: 10px;
      z-index: 1;
    }
    .dizuo {
      z-index: 0;
      position: absolute;
      width: 1006px;
      height: 58px;
      bottom: -35px;
    }
  }
  .zhishi {
    margin-top: 44px;
  }
}
.ditu {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/view/about.vue